export class UserLicenceDetailsEntity {
    UserId: number;
    UserName: string;
    UserGroup: string;
    UserMailId: string;
    DeviceId: string;
    DeviceName: string;
    DeviceType: string;
    LoginTime: string;
    LogoutTime: string;
    LastAccessTime: string;
    usertoken: string;
    InstanceId: number;
    SiteId: number;
    SiteName: string;
    IsActive: boolean;
    LogoutBy: string;
    CurrentTime: string;
  }


